module.exports = __webpack_public_path__ + "static/media/weekly-report-icon-inactive.0f701627.svg";